export default function buildTsv(headers, rows) {
  return [headers.join('\t'), ...rows.map((row) => row.join('\t'))].join('\n');
}
